import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FirstPage as IconFirstPage, KeyboardArrowLeft as IconKeyboardArrowLeft, KeyboardArrowRight as IconKeyboardArrowRight, LastPage as IconLastPage, } from "@mui/icons-material";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { UiIconButton } from "../ui_icon_button";
import { UiSpinner } from "../ui_spinner";
import { UiTableCell } from "../ui_table_cell";
import { useStyles } from "./ui_table.css";
export const UiTable = ({ columns, gutterBottom, isLoading, items, pageSize, sortFunction, }) => {
    const [page, setPage] = useState(0);
    const classes = useStyles({ gutterBottom });
    const pagesAmount = Math.ceil(items.length / pageSize);
    const isFirstPage = useMemo(() => page === 0, [page]);
    const isLastPage = useMemo(() => page + 1 === pagesAmount, [page, pagesAmount]);
    const itemsSorted = useMemo(() => {
        if (sortFunction) {
            return items.sort(sortFunction);
        }
        else {
            return items;
        }
    }, [items, sortFunction]);
    const hasHead = useMemo(() => columns.some(({ title }) => !!title), [columns]);
    const handleNavigateFirstPage = useCallback(() => {
        setPage(0);
    }, []);
    const handleNavigateLastPage = useCallback(() => {
        setPage(pagesAmount - 1);
    }, [pagesAmount]);
    const handleNavigateNextPage = useCallback(() => {
        setPage(page + 1);
    }, [page]);
    const handleNavigatePreviousPage = useCallback(() => {
        setPage(page - 1);
    }, [page]);
    return useMemo(() => !isLoading ? (_jsxs(_Fragment, { children: [_jsxs(Table, { classes: { root: classes.ui_table }, children: [hasHead && (_jsx(TableHead, { children: _jsx(TableRow, { children: columns.map((column, idx) => (_jsx(TableCell, { align: column.align, children: column.title }, idx))) }) })), _jsx(TableBody, { children: itemsSorted
                            .slice(page * pageSize, (page + 1) * pageSize)
                            .map((item, idx) => (_jsx(TableRow, { children: columns.map((column, idx) => (_jsx(UiTableCell, { align: column.align, maxWidth: column.maxWidth, minWidth: column.minWidth, width: column.width, whiteSpace: column.whiteSpace, padding: column.padding, children: column.Cell(item) }, idx))) }, idx))) })] }), pagesAmount > 1 && (_jsxs(Box, { display: "flex", justifyContent: "flex-end", padding: 2, children: [_jsxs(Box, { alignItems: "center", display: "flex", paddingRight: 2, children: [page * pageSize + 1, "-", (page + 1) * pageSize >= itemsSorted.length
                                ? itemsSorted.length
                                : (page + 1) * pageSize, " ", "of ", itemsSorted.length] }), _jsxs(Box, { children: [_jsx(UiIconButton, { disabled: isFirstPage, onClick: handleNavigateFirstPage, children: _jsx(IconFirstPage, {}) }), _jsx(UiIconButton, { disabled: isFirstPage, onClick: handleNavigatePreviousPage, children: _jsx(IconKeyboardArrowLeft, {}) }), _jsx(UiIconButton, { disabled: isLastPage, onClick: handleNavigateNextPage, children: _jsx(IconKeyboardArrowRight, {}) }), _jsx(UiIconButton, { disabled: isLastPage, onClick: handleNavigateLastPage, children: _jsx(IconLastPage, {}) })] })] }))] })) : (_jsx(UiSpinner, {})), [
        classes.ui_table,
        columns,
        handleNavigateFirstPage,
        handleNavigateLastPage,
        handleNavigateNextPage,
        handleNavigatePreviousPage,
        hasHead,
        isFirstPage,
        isLastPage,
        isLoading,
        itemsSorted,
        page,
        pageSize,
        pagesAmount,
    ]);
};
//# sourceMappingURL=ui_table.js.map